import request from '@/utils/request'
import qs from 'qs'


const api = {
  h_index:'/n/getHospitalInfo',//医院简介
  og_index:'/n/getHospitalGuide',//操作指南列表
  og_detail:'/n/getHospitalGuideInfo',//操作指南系详情
  og_likeNum:'/n/znlookNum',//操作指南的点赞
  dept_index:'/n/getDepartList1',//科室列表 table后端固定返回格式
  dept_detail:'/n/getDepartInfo',//科室详情对象
  dept_list:'/n/getdptList',//科室列表
  doctor_detail:'/n/getDoctorInfo',//医生详情
  doctor_index:'n/getDoctorList',//根据科室id获取医生列表
  question_help_index:'/n/getAssistlist',//问题与帮助的列表
  question_likeNum:'/n/uplookNum',//问题与帮助的点赞
  question_detail:'/n/getAssistInfo',//问题与帮助的详情
  getPaib:'/n/getPaib',//获取专家坐诊信息
  getYpxx:'/n/getYpzx',//获取药品信息
  getChuangwgs:'/cw/getChuangwgs',//床位公示信息
  getYsczList:'/yscz/getYsczList'//医生出诊公示
}
//医生出诊公示
export function getYsczList(parameter) {
  return request({
    url: api.getYsczList,
    method: 'post',
    data: qs.stringify(parameter)
  })
}
//获取床位信息
export function getChuangwgs(parameter) {
  return request.post(api.getChuangwgs, parameter);
}
//获取药品信息
export function getYpxx(parameter) {
	return request.post(api.getYpxx, parameter);
}
//查询医院简介
export function getHIndex (parameter) {
  return request.get(api.h_index,parameter);
}

//获取操作指南列表
export function getOGIndex(parameter){
  return request.post(api.og_index,parameter);
}
//获取操作指南详情
export function getOGDetail(parameter){
  return request.post(api.og_detail,parameter);
}
//响应操作指南的点赞事件
export function doOGLikeNum(parameter){
  return request.post(api.og_likeNum,parameter);
}

//获取科室列表数据 table
export function getDeptIndex(parameter){
  return request.post(api.dept_index,parameter);
}
//获取该科室详情对象
export function getDeptDetail(parameter){
  return request.post(api.dept_detail,parameter);
}
//获取科室列表数据
export function getDeptList(parameter){
  return request.post(api.dept_list,parameter);
}

//获取医生详情
export function getDoctorDetail(parameter){
  return request.post(api.doctor_detail,parameter);
}
//根据科室id获取医生列表
export function getDoctorIndex(parameter){
  return request.post(api.doctor_index,parameter);
}

//获取问题与帮助的列表数据
export function getQuestionHelpIndex(parameter){
  return request.post(api.question_help_index,parameter);
}

//响应问题与帮助的点赞事件
export function doQuestionLikeNum(parameter){
  return request.post(api.question_likeNum,parameter);
}
//获取问题与帮助详情对象
export function getQuestionDetail(parameter){
  return request.post(api.question_detail,parameter);
}

// 获取专家坐诊信息
export function getPaib(parameter){
  return request.get(
      api.getPaib,
     parameter
  )
}
